/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable no-prototype-builtins */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import parse, { domToReact } from 'html-react-parser';
import PropTypes from 'prop-types';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import { parseCss } from 'gatsby-core-theme/src/helpers/css-parser';
import Button from 'gatsby-core-theme/src/components/atoms/button';
import { FaEnvelope } from '@react-icons/all-files/fa/FaEnvelope';
import { FaChevronCircleRight } from '@react-icons/all-files/fa/FaChevronCircleRight';

import { translate, prettyTracker } from 'gatsby-core-theme/src/helpers/getters';
import StarRating from 'gatsby-core-theme/src/components/molecules/star-rating';
import { Context } from '~context/MainProvider';

import styles from './content.module.scss';

const Content = ({ module, pageContext, contactEmail = 'mailto:kontakt@sesport.dk' }) => {
  const replaceMedia = (node) => {
    if (node.name === 'img') {
      let stylesClass = null;
      const classes = node.attribs.class;
      if (classes?.includes('content-image--float-left')) {
        stylesClass = 'floatLeft';
      } else if (classes?.includes('content-image--float-right')) {
        stylesClass = 'floatRight';
      } else if (classes?.includes('content-image--align-center')) {
        stylesClass = 'alignCenter';
      } else if (classes?.includes('content-image--align-left')) {
        stylesClass = 'alignLeft';
      } else if (classes?.includes('content-image--align-right')) {
        stylesClass = 'alignRight';
      }

      const lazyProps = {
        src: node.attribs.src,
        style: node.attribs.style ? parseCss(node.attribs.style) : null,
        alt: node.attribs.alt ? node.attribs.alt : 'missing alt',
        className: styles[stylesClass],
      };
      return <LazyImage {...lazyProps} />;
    }

    if (node.name === 'table') {
      return (
        <div className={styles.tableResponsive}>
          <table>{domToReact(node.children, node.options)}</table>
        </div>
      );
    }
    return null;
  };
  const replaceStars = (node) => {
    if (
      node.name === 'i' &&
      node.attribs.hasOwnProperty('class') &&
      node.attribs.class.includes('star')
    ) {
      const starProps = {
        rating: node.attribs.data,
      };
      return <StarRating {...starProps} halfStars numOfStars={5} />;
    }
    return null;
  };
  const provider = pageContext?.page?.relation?.provider;
  const { translations } = useContext(Context) || {};
  const style = module?.style;

  return (
    <div className={`${styles.grid} ${styles[style]}`}>
      {style === 'review_content' && <div className={styles.bg} />}
      <div>
        {style === 'review_content'
          ? module.value &&
            style !== 'contact_us' &&
            parse(module.value, {
              replace: replaceStars,
            })
          : module.value &&
            style !== 'contact_us' &&
            parse(module.value, {
              replace: replaceMedia,
            })}

        {style === 'contact_us' && (
          <div className={styles.centerBtn}>
            <Button
              to={contactEmail}
              className="soccer"
              isAnchorLink
              isInternalLink={false}
              btnText={
                <>
                  <FaEnvelope />
                  {translate(translations, 'contact_us', 'Contact us')}
                </>
              }
              gtmClass="content-gtm contact-gtm btn-cta"
            />
          </div>
        )}
        {style === 'review_content' && (
          <div className={styles.blockBtn}>
            <Button
              to={prettyTracker(provider, 'main', true)}
              className="primary"
              isInternalLink={false}
              targetBlank={false}
              btnText={
                <>
                  <FaChevronCircleRight />
                  {`${translate(translations, 'go_to', 'Go to')} ${provider?.name}`}
                </>
              }
              gtmClass="content-gtm review-gtm btn-cta"
            />
          </div>
        )}
      </div>
    </div>
  );
};

Content.propTypes = {
  module: PropTypes.shape({
    anchor_label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    style_id: PropTypes.number,
  }),
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      template: PropTypes.string,
      relation: PropTypes.shape({}),
    }),
  }),

  contactEmail: PropTypes.string,
};

export default Content;
